<!-------------bannner------------>
<div class="banner-part"> <img src="/assets/images/donate-banner.jpg" alt="">
  <div class="container">
    <div class="wraper">
      <h1>{{ '::Receipts:Title' | abpLocalization }}</h1>
    </div>
  </div>
</div>

  <div class="container" style="padding: 10%" *ngIf="hasLoggedIn" [abpLoading]="uiBusy">
    <div class="row">
      <div class="col-12">
        <div *ngIf="memberInfo.isMember">
          <div class="row" >
            <div class="col-12 col-md-6">
              <h2 *ngIf="currentUserInfo">{{memberInfo.member.name}} {{memberInfo.member.surname}}</h2>
              <div>{{ '::Receipts:MembershipId' | abpLocalization }}: {{memberInfo.member.extraProperties.LegacyMembershipId}}</div>
              <div>{{memberInfo.member.addressLine1}}</div>
              <div>{{memberInfo.member.addressLine2}}</div>
              <div>{{memberInfo.member.addressLine3}} {{memberInfo.member.postalCode}}</div>
                            <div>{{ '::Receipts:Phone' | abpLocalization }}: {{memberInfo.member.phoneNumber}}</div>


<!-- Subscription Management Section -->
<br><br>
<h6>{{ '::Membership:SubscriptionManagement' | abpLocalization : 'Subscription Management' }}</h6>
<div style="margin-bottom: 15px;">
  <!-- <button 
    class="btn btn-primary btn-sm mb-2" 
    style="display: block;"
    (click)="loadSubscriptions()"
    [disabled]="subscriptionsLoading">
    <i class="fa fa-credit-card me-1"></i>
    {{ showSubscriptions ? ('::Receipts:HideSubscriptions' | abpLocalization : 'Hide Subscriptions') : ('::Receipts:ViewSubscriptions' | abpLocalization : 'View My Subscriptions') }}
    <i class="fa fa-spinner fa-spin ms-1" *ngIf="subscriptionsLoading"></i>
  </button> -->
  
  <!-- <button 
    class="btn btn-outline-primary btn-sm ml-2" 
    style="display: block;"
    (click)="openBillingPortal()"
    [disabled]="uiBusy">
    <i class="fa fa-cogs me-1"></i>
    {{ '::Membership:ManageSubscriptions' | abpLocalization : 'Manage Subscriptions' }}
  </button> -->
</div>

<!-- Subscriptions List -->
<div *ngIf="showSubscriptions" class="subscription-details mt-3">
  <div *ngIf="customerSubscriptions && customerSubscriptions.subscriptions.length > 0" class="card">
    <div class="card-header">
      <h6 class="mb-0">
        <i class="fa fa-credit-card me-2"></i>
        {{ '::Membership:YourSubscriptions' | abpLocalization : 'Your Subscriptions' }}
        <span class="badge bg-primary ms-2">{{customerSubscriptions.totalSubscriptions}}</span>
      </h6>
      <small class="text-muted">
        {{ '::Membership:ActiveSubscriptions' | abpLocalization : 'Active' }}: {{customerSubscriptions.activeSubscriptions}} | 
        {{ '::Membership:TotalMonthly' | abpLocalization : 'Total Monthly' }}: ${{customerSubscriptions.totalMonthlyAmount}} CAD
      </small>
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3"></div>
        <div class="col-2"><strong>{{ '::Membership:Amount' | abpLocalization : 'Amount' }}</strong></div>
        <!-- <div class="col-2"><strong>{{ '::Membership:Status' | abpLocalization : 'Status' }}</strong></div> -->
        <div class="col-2"><strong>{{ '::Membership:NextBilling' | abpLocalization : 'Next Billing' }}</strong></div>
        <div class="col-3"><strong>{{ '::Membership:Created' | abpLocalization : 'Created' }}</strong></div>
        <div class="col-2"><strong>{{ '::Manage' | abpLocalization : 'Manage' }}</strong></div>
      </div>
      <hr>
      <div class="row mb-2" *ngFor="let subscription of customerSubscriptions.subscriptions">
        <div class="col-3">
          <strong>{{subscription.productName}}</strong>
          <br>
          <small class="text-muted">{{subscription.productDescription}}</small>
        </div>
        <div class="col-2">
          {{formatSubscriptionAmount(subscription)}}
        </div>
        <!-- <div class="col-2">
          <span [class]="getSubscriptionStatusBadgeClass(subscription.status)">
            {{subscription.status | titlecase}}
          </span>
        </div> -->
        <div class="col-2">
          <small>{{formatDate(subscription.nextInvoiceDate)}}</small>
        </div>
        <div class="col-3">
          <small>{{formatDate(subscription.createdAt)}}</small>
        </div>
        <div class="col-2">
          
          <button class="btn btn-outline-primary btn-sm" (click)="openBillingPortal(subscription.customerId)" target="_blank">
            <i class="fa fa-cog"></i><!-- {{ '::Manage' | abpLocalization }} -->
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="customerSubscriptions && customerSubscriptions.subscriptions.length === 0" class="alert alert-info">
    <i class="fa fa-info-circle me-2"></i>
    {{ '::Membership:NoSubscriptions' | abpLocalization : 'You don\'t have any active subscriptions yet.' }}
  </div>
  
  <div *ngIf="!customerSubscriptions && !subscriptionsLoading" class="alert alert-warning">
    <i class="fa fa-exclamation-triangle me-2"></i>
    {{ '::Membership:NoStripeCustomer' | abpLocalization : 'No Stripe customer found with your email address.' }}
  </div>
</div>

                <!-- {{memberInfo.member.addressLine1 | json}} -->
              <br><Br>
              
              <h3>{{ '::Receipts:AnnualReceipts' | abpLocalization }}</h3>
              <ul style="padding-left:0;">
                <li style="display: inline-block; margin-bottom: 20px" *ngFor="let year of previousYears">
                  <span 
                  (click)="getAnnualReceipt(getPaymentsByUser(memberInfo.payments, activeUserId)[0].id, year)"
                  class="btn btn-primary" style="margin-right: 10px; margin-left: 10px;">
                    <i class="fa cursor-pointer fa-download"></i>&nbsp; {{year}}
    
                  </span>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-6">
              <h5>{{ '::Receipts:DonationReceipts' | abpLocalization }}</h5>
              <div class="row">
                <div class="col-5"><strong>{{ '::Receipts:PaymentType' | abpLocalization }}</strong></div>
                <div class="col-2"><strong>{{ '::Receipts:Amount' | abpLocalization }}</strong></div>
    
                <!-- <div class="col-2"><strong>Year</strong></div> -->
                <div class="col-3"><strong>{{ '::Receipts:ReceivedDate' | abpLocalization }}</strong></div>
    
                
              </div>
              <div class="row" *ngFor="let payment of getPaymentsByUser(memberInfo.payments, activeUserId)">
    
                <div class="col-5">
                  <span (click)="getReceipt(payment.id)" class="fa cursor-pointer fa-download"></span> &nbsp;
                 
                  {{getPaymentType(payment.paymentTypeId)}}
                </div>
                <div class="col-2">${{payment.amount}}</div>
    
                <!-- <div class="col-2">{{payment.accountingYear}}</div> -->
                <div class="col-3">{{payment.creationTime | date : 'dd-MMM-yyyy'}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row" *ngFor="let member of familyMembers">
                    <div class="col-12 col-md-6">
                      <!-- <h5>Info For:  <span>
                        {{member.name}}!
                      </span></h5> -->
                      <br><Br>
        
                      <h5>{{member.name}} ({{ '::Receipts:MembershipId' | abpLocalization }}: {{member.extraProperties.LegacyMembershipId}}) </h5>
                      {{ '::Receipts:MembershipReceipts' | abpLocalization }}
                      <ul style="padding-left:0;">
                        <li style="display: inline-block;" *ngFor="let payment of getPaymentsByUser(membershipPayments, member.id) | orderBy: 'accountingYear'">
                          <span (click)="getReceipt(payment.id)" class="btn btn-primary" style="margin-right: 5px; margin-left: 5px; margin-bottom: 10px;">
                            <i class="fa cursor-pointer fa-download" *ngIf="payment.id"></i>&nbsp;
        
                            <!-- <i class="fa fa-receipt" *ngIf="payment.id"></i> -->
                            {{payment.accountingYear}}
            
                          </span>
                        </li>
                      </ul>
                      
                    </div>
                    <div class="col-12 col-md-6">
                      <br><br>
                      <div class="row">
                        <div class="col-5"><strong>{{ '::Receipts:PaymentType' | abpLocalization }}</strong></div>
                        <div class="col-2"><strong>{{ '::Receipts:Amount' | abpLocalization }}</strong></div>
            
                        <div class="col-2"><strong>{{ '::Receipts:Year' | abpLocalization }}</strong></div>
                        <div class="col-3"><strong>{{ '::Receipts:ReceivedDate' | abpLocalization }}</strong></div>
            
                        
                      </div>
                      <div class="row" *ngFor="let payment of getPaymentsByUser(memberInfo.payments, member.id)">
            
                        <div class="col-5">
                          <span (click)="getReceipt(payment.id)" class="fa cursor-pointer fa-download"></span> &nbsp;
                 
                          {{getPaymentType(payment.paymentTypeId)}}</div>
                        <div class="col-2">${{payment.amount}}</div>
            
                        <div class="col-2">{{payment.accountingYear}}</div>
                        <div class="col-3">{{payment.creationTime | date}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
    
          </div>
        </div>
        <div class="row" *ngIf="!memberInfo">
          <div class="col-12">
            <div *ngIf="currentUserInfo" class="header-btn d-none d-sm-block ml-lg-4" style="margin-top: 15px">
              {{ '::Receipts:NoReceipts' | abpLocalization }}
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>



<p-dialog header="{{ '::Receipts:DialogTitle' | abpLocalization }}" [(visible)]="displayMessage">
  {{messageContent}}
</p-dialog>